module.exports = __webpack_public_path__ + "static/media/old-car-removal-coopers.141f78a9.png";